import React, { useEffect } from "react";
import { FormHelperText } from "@mui/material";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import errorMessageHelper from "../ErrorMessageHelper";

const FormTextfield = ({
  label,
  formName,
  field,
  type,
  error,
  onKeyDown,
  multiline,
  autoComplete = "off",
}) => {
  const [showPassword, setShowPassword] = React.useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <>
      <FormControl fullWidth={true} variant="outlined">
        <InputLabel
          htmlFor="outlined-adornment-password"
          sx={{
            fontFamily: "Poppins",
            "&.Mui-Focused": {
              color: "red",
            },
            "&.MuiInputLabel-shrink": {
              color: error && "red",
            },
          }}
        >
          {label}
        </InputLabel>

        <OutlinedInput
          id="outlined-adornment-password"
          label={label}
          error={error !== undefined}
          fullWidth={true}
          type={
            type === "password" ? (showPassword ? "text" : "password") : "text"
          }
          {...field}
          multiline={multiline ?? false}
          maxRows={6}
          autoComplete
          inputProps={{
            autoComplete: "on",
          }}
          sx={{
            fontFamily: "Poppins",
            borderColor: "#2645E6",
            ".Mui-focused": {
              color: "var(--primaryColor)!important",
            },
            "& .MuiOutlinedInput-root": {
              "&.Mui-focused fieldset": {
                borderColor: "#2645E6",
              },
            },
          }}
          onKeyPress={onKeyDown}
          endAdornment={
            type === "password" ? (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ) : null
          }
        />
        {!!error && (
          <FormHelperText
            sx={{
              marginLeft: "14px",
              color: "red",
              marginTop: 0,
            }}
          >
            {errorMessageHelper[formName] !== undefined &&
            error !== undefined &&
            error?.type !== undefined
              ? errorMessageHelper[formName][error?.type]
              : ""}
          </FormHelperText>
        )}
      </FormControl>
    </>
  );
};

export default FormTextfield;
